import { addAndTrack } from "../../../calculators/helpers";
import { Dendro, Green } from "../../../styledCpns/DataDisplay";
import { CaStamina, mediumPAs } from "../config";
import {
  checkAscs,
  checkCharMC,
  checkCons,
  makeTlBnes,
  xtraTlLv
} from "../helpers";
import { getFinalTlLv, round3 } from "../../../helpers";
import tlLvMults from "../tlLvMults";
import { NAs } from "../../../configs";

const Alhaitham = {
  code: 65,
  name: "Alhaitham",
  icon: "2/2c/Alhaitham_Icon",
  sideIcon: "e/ed/Character_Alhaitham_Side_Icon",
  rarity: 5,
  nation: "Sumeru",
  vision: "Dendro",
  weapon: "Sword",
  stats: [
    { "Base HP": 1039, "Base ATK": 24, "Base DEF": 61 },
    { "Base HP": 2695, "Base ATK": 63, "Base DEF": 158 },
    { "Base HP": 3586, "Base ATK": 84, "Base DEF": 210 },
    { "Base HP": 5366, "Base ATK": 126, "Base DEF": 314 },
    {
      "Base HP": 5999,
      "Base ATK": 141,
      "Base DEF": 351,
      "Dendro DMG Bonus": 7.2
    },
    {
      "Base HP": 6902,
      "Base ATK": 162,
      "Base DEF": 404,
      "Dendro DMG Bonus": 7.2
    },
    {
      "Base HP": 7747,
      "Base ATK": 182,
      "Base DEF": 454,
      "Dendro DMG Bonus": 14.4
    },
    {
      "Base HP": 8659,
      "Base ATK": 203,
      "Base DEF": 507,
      "Dendro DMG Bonus": 14.4
    },
    {
      "Base HP": 9292,
      "Base ATK": 218,
      "Base DEF": 544,
      "Dendro DMG Bonus": 14.4
    },
    {
      "Base HP": 10213,
      "Base ATK": 240,
      "Base DEF": 598,
      "Dendro DMG Bonus": 14.4
    },
    {
      "Base HP": 10846,
      "Base ATK": 255,
      "Base DEF": 635,
      "Dendro DMG Bonus": 21.6
    },
    {
      "Base HP": 11777,
      "Base ATK": 276,
      "Base DEF": 690,
      "Dendro DMG Bonus": 21.6
    },
    {
      "Base HP": 12410,
      "Base ATK": 291,
      "Base DEF": 727,
      "Dendro DMG Bonus": 28.8
    },
    {
      "Base HP": 13348,
      "Base ATK": 313,
      "Base DEF": 782,
      "Dendro DMG Bonus": 28.8
    }
  ],
  actvTalents: [
    {
      type: "Normal Attack",
      name: "Sword of Hetuvidya",
      desc: [],
      stats: [
        {
          name: "1-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 49.53,
          multType: 1
        },
        {
          name: "2-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 50.75,
          multType: 1
        },
        {
          name: "3-Hit (1/2)",
          dmgTypes: ["NA", "Physical"],
          baseMult: 34.18,
          multType: 1
        },
        {
          name: "4-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 66.77,
          multType: 1
        },
        {
          name: "5-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 83.85,
          multType: 1
        },
        {
          name: "Charged Attack (1/2)",
          dmgTypes: ["CA", "Physical"],
          baseMult: 55.26,
          multType: 1
        },
        CaStamina[20],
        ...mediumPAs
      ]
    },
    {
      type: "Elemental Skill",
      name: "Universality: An Elaboration on Form",
      image: "2/29/Talent_Universality_An_Elaboration_on_Form",
      desc: [],
      getXtraLv: xtraTlLv.cons3,
      stats: [
        {
          name: "Rush Attack DMG",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 193.6,
          multType: 2,
          getTlBnes: ({ ATTRs, char, partyData }) => {
            const EM = ATTRs["Elemental Mastery"];
            const level = getFinalTlLv(
              char,
              Alhaitham.actvTalents[1],
              partyData
            );
            const emPartMult = 154.88 * tlLvMults[2][level];
            const emPart = Math.round((emPartMult / 100) * EM);

            return makeTlBnes(
              true,
              "flat",
              `Elemental Mastery Part (Elemental Mastery ${EM} * Talent Mult. ${round3(
                emPartMult
              )}%)`,
              emPart
            );
          }
        },
        {
          name: "1-Mirror Projection DMG",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 67.2,
          multType: 2,
          getTlBnes: ({ ATTRs, char, selfMCs, partyData }) => {
            const EM = ATTRs["Elemental Mastery"];
            const level = getFinalTlLv(
              char,
              Alhaitham.actvTalents[1],
              partyData
            );
            const emPartMult = 134.4 * tlLvMults[2][level];
            const emPart = Math.round((emPartMult / 100) * EM);

            return makeTlBnes([
              [
                true,
                "flat",
                `Elemental Mastery Part (Elemental Mastery ${EM} * Talent Mult. ${round3(
                  emPartMult
                )}%)`,
                emPart
              ],
              [
                checkCharMC(Alhaitham.buffs, char, selfMCs.BCs, 1),
                "pct",
                [1, 4],
                Math.min(EM * 0.1, 100)
              ]
            ]);
          }
        },
        {
          name: "2-Mirror Projection DMG (1/2)",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 67.2,
          multType: 2,
          getTlBnes: ({ ATTRs, char, selfMCs, partyData }) => {
            const EM = ATTRs["Elemental Mastery"];
            const level = getFinalTlLv(
              char,
              Alhaitham.actvTalents[1],
              partyData
            );
            const emPartMult = 134.4 * tlLvMults[2][level];
            const emPart = Math.round((emPartMult / 100) * EM);

            return makeTlBnes([
              [
                true,
                "flat",
                `Elemental Mastery Part (Elemental Mastery ${EM} * Talent Mult. ${round3(
                  emPartMult
                )}%)`,
                emPart
              ],
              [
                checkCharMC(Alhaitham.buffs, char, selfMCs.BCs, 1),
                "pct",
                [1, 4],
                Math.min(EM * 0.1, 100)
              ]
            ]);
          }
        },
        {
          name: "3-Mirror Projection DMG (1/3)",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 67.2,
          multType: 2,
          getTlBnes: ({ ATTRs, char, selfMCs, partyData }) => {
            const EM = ATTRs["Elemental Mastery"];
            const level = getFinalTlLv(
              char,
              Alhaitham.actvTalents[1],
              partyData
            );
            const emPartMult = 134.4 * tlLvMults[2][level];
            const emPart = Math.round((emPartMult / 100) * EM);

            return makeTlBnes([
              [
                true,
                "flat",
                `Elemental Mastery Part (Elemental Mastery ${EM} * Talent Mult. ${round3(
                  emPartMult
                )}%)`,
                emPart
              ],
              [
                checkCharMC(Alhaitham.buffs, char, selfMCs.BCs, 1),
                "pct",
                [1, 4],
                Math.min(EM * 0.1, 100)
              ]
            ]);
          }
        }
      ]
      // otherStats: () => []
    },
    {
      type: "Elemental Burst",
      name: "Particular Field: Fetters of Phenomena",
      image: "0/08/Talent_Particular_Field_Fetters_of_Phenomena",
      desc: [],
      getXtraLv: xtraTlLv.cons5,
      stats: [
        {
          name: "Single-Instance DMG",
          dmgTypes: ["EB", "Elemental"],
          baseMult: 121.6,
          multType: 2,
          getTlBnes: ({ ATTRs, char, partyData }) => {
            const EM = ATTRs["Elemental Mastery"];
            const level = getFinalTlLv(
              char,
              Alhaitham.actvTalents[1],
              partyData
            );
            const emPartMult = 97.28 * tlLvMults[2][level];
            const emPart = Math.round((emPartMult / 100) * EM);

            return makeTlBnes(
              true,
              "flat",
              `Elemental Mastery Part (Elemental Mastery ${EM} * Talent Mult. ${round3(
                emPartMult
              )}%)`,
              emPart
            );
          }
        }
      ],
      otherStats: () => [{ name: "CD", value: "18s" }],
      energyCost: 70
    }
  ],
  pasvTalents: [
    {
      type: "Ascension 1",
      name: "Four-Causal Correction",
      image: "3/32/Talent_Four-Causal_Correction",
      desc: (
        <>
          When Alhaitham's Charged and Plunging Attacks hit opponents, they will
          create 1 Chisel-Light Mirror. This effect can be triggered once every
          12s.
        </>
      )
    },
    {
      type: "Ascension 4",
      name: "Mysteries Laid Bare",
      image: "f/f4/Talent_Mysteries_Laid_Bare",
      desc: (
        <>
          Each point of Alhaitham's Elemental Mastery will increase the{" "}
          <Green>DMG</Green> dealt by Projection Attacks [/ES] and Particular
          Field: Fetters of Phenomena [EB] by <Green b>0.1%</Green>. Max 100%.
        </>
      )
    },
    {
      type: "Passive",
      name: "Law of Reductive Overdetermination",
      image: "a/a4/Talent_Law_of_Reductive_Overdetermination",
      desc: <></>
    }
  ],
  constellation: [
    {
      name: "Intuition",
      image: "c/c9/Constellation_Intuition",
      desc: (
        <>
          When a Projection Attack hits an opponent, Universality: An
          Elaboration on Form's CD is decreased by 1.2s. This effect can be
          triggered once every 1s.
        </>
      )
    },
    {
      name: "Debate",
      image: "9/9d/Constellation_Debate",
      get desc() {
        return (
          <>
            {this.buff}
            Each stack's duration is counted independently. This effect can be
            triggered even when the maximum number of Chisel-Light Mirrors has
            been reached.
          </>
        );
      },
      buff: (
        <>
          When Alhaitham generates a Chisel-Light Mirror, his{" "}
          <Green>Elemental Mastery</Green> will be increased by{" "}
          <Green b>50</Green> for 8 seconds, max 4 stacks.
        </>
      )
    },
    {
      name: "Negation",
      image: "4/4f/Constellation_Negation",
      desc: "Universality: An Elaboration on Form"
    },
    {
      name: "Elucidation",
      image: "b/b5/Constellation_Elucidation",
      desc: (
        <>
          Buff based on the number of Chisel-Light Mirrors consumed and
          generated by Particular Field: Fetters of Phenomena [EB]:
          <br />• Each Mirror consumed will increase the{" "}
          <Green>Elemental Mastery</Green> of all other nearby party members by{" "}
          <Green b>30</Green> for 15s.
          <br />• Each Mirror generated will grant Alhaitham a{" "}
          <Green b>10%</Green> <Green>Dendro DMG Bonus</Green> for 15s.
        </>
      )
    },
    {
      name: "Sagacity",
      image: "c/c0/Constellation_Sagacity",
      desc: "Particular Field: Fetters of Phenomena"
    },
    {
      name: "Structuration",
      image: "5/55/Constellation_Structuration",
      get desc() {
        return (
          <>
            2 seconds after Particular Field: Fetters of Phenomena is unleashed,
            he will generate 3 Chisel-Light Mirrors regardless of the number of
            mirrors consumed.
            <br />
            {this.buff}
            <br />
            If this effect is triggered again during its initial duration, the
            duration remaining will be increased by 5s.
          </>
        );
      },
      buff: (
        <>
          If Alhaitham creates a Chisel-Light Mirror when their numbers have
          already maxed out, then each excess Chisel-Light Mirror will increase
          his <Green>CRIT Rate</Green> by <Green b>10%</Green> and{" "}
          <Green>CRIT DMG</Green> by <Green b>70%</Green> for 5s.
        </>
      )
    }
  ],
  buffs: [
    {
      index: 0,
      src: "Chisel-Light Mirrors",
      desc: () => (
        <>
          When he possesses Chisel-Light Mirrors, Alhaitham's Normal, Charged,
          and Plunging Attacks will be converted to <Dendro>Dendro DMG</Dendro>.
        </>
      ),
      isGranted: () => true,
      affect: "self",
      canInfuse: () => true,
      infuseRange: NAs,
      canBeOverrided: false
    },
    {
      index: 1,
      src: "Ascension 4 Passive",
      desc: () => Alhaitham.pasvTalents[1].desc,
      isGranted: checkAscs[4],
      affect: "self",
      addBnes: ({ tkDesc, ATTRs, hitBnes, tracker }) => {
        const bnValue = Math.min(ATTRs["Elemental Mastery"] * 0.1, 100);
        addAndTrack(tkDesc, hitBnes, "EB.pct", bnValue, tracker);
      }
    },
    {
      index: 2,
      src: "Constellation 2",
      desc: () => Alhaitham.constellation[1].buff,
      isGranted: checkCons[2],
      affect: "self",
      selfLabels: ["Stacks"],
      inputs: [1],
      inputTypes: ["select"],
      maxs: [4],
      addBnes: ({ tkDesc, ATTRs, inputs = [], tracker }) => {
        const bnValue = inputs[0] * 50;
        addAndTrack(tkDesc, ATTRs, "Elemental Mastery", bnValue, tracker);
      }
    },
    {
      index: 3,
      src: "Constellation 4",
      desc: () => Alhaitham.constellation[3].desc,
      isGranted: checkCons[4],
      affect: "party",
      labels: ["Consumed Mirrors"],
      selfLabels: ["Consumed Mirrors"],
      inputs: [1],
      inputTypes: ["select"],
      maxs: [3],
      addBnes: ({ toSelf, tkDesc, ATTRs, inputs = [], tracker }) => {
        if (toSelf) {
          const bnValue = (3 - inputs[0]) * 10;
          addAndTrack(tkDesc, ATTRs, "Dendro DMG Bonus", bnValue, tracker);
        } else {
          const bnValue = inputs[0] * 30;
          addAndTrack(tkDesc, ATTRs, "Elemental Mastery", bnValue, tracker);
        }
      }
    },
    {
      index: 4,
      src: "Constellation 6",
      desc: () => Alhaitham.constellation[5].buff,
      isGranted: checkCons[6],
      affect: "self",
      selfLabels: ["Excess Mirrors"],
      inputs: [1],
      inputTypes: ["select"],
      maxs: [5],
      addBnes: ({ tkDesc, ATTRs, inputs = [], tracker }) => {
        const bnValues = [inputs[0] * 10, inputs[0] * 70];
        const fields = ["CRIT Rate", "CRIT DMG"];
        addAndTrack(tkDesc, ATTRs, fields, bnValues, tracker);
      }
    }
  ]
};

export default Alhaitham;
